import React, { useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

//Redux

//Components
import DataTable from "react-data-table-component";
import Layout from "../../../../Layout/Layout";
// import Constants from "../../../../common/SupplierConstants";
import { formatDateTime, formatNumber } from "../../../../common/Validations";

//Serivce
// import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import UploadXlSheetModal from "./UploadXlSheetModal";

const OrderBulckUpload = () => {
  localStorage.setItem("menu", "");
  localStorage.setItem("submenu", "");

  const [isCardVisible1, setCardVisible1] = useState(true);
  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };

  const [data, setData] = useState();

  const [getShowSupplierInviteModal, setShowSupplierInviteModal] =
    useState(false);

  const orderSchedulingListColInfo = [
    {
      name: "Order",
      selector: (row) => row.documentNumber,
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-new-status">
            {row.documentNumber}
          </span>
        </>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Created Date",
      selector: (row) => row.createdAt,
      cell: (row) => (
        <>
          <span className="fw-bold text-primary">
            {formatDateTime(row.createdAt)}
          </span>
        </>
      ),
      sortable: true,
      width: "130px",
    },
    {
      name: "Company Code",
      selector: (row) => row.companyCodeDesc,
      cell: (row) => (
        <>
          <span className="fw-bold text-success">{row.companyCodeDesc}</span>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Customer",
      selector: (row) => row.sapDocumentNumber,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1 fw-bold ">{row.customerName} </p>
            <p className="m-0 p-0 ">{row.sapDocumentNumber} </p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    // {
    //   name: "Item Nr",
    //   selector: (row) => row.sapDocumentNumber,
    //   cell: (row) => (
    //     <>
    //       <div>
    //         <p className="m-0 p-0 pt-1 fw-bold ">{row?.local_id} </p>
    //       </div>
    //     </>
    //   ),
    //   sortable: true,
    //   width: "140px",
    // },
    {
      name: "Material",
      selector: (row) => row?.materialCode,
      cell: (row) => (
        <>
          <div>
            {/* <p className="m-0 p-0  fw-bold">
              {row?.materialDescription}{" "}
            </p> */}
            <p className="m-0 p-0 pt-1  ">{row?.materialCode} </p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Qty",
      selector: (row) => row?.items?.orderQuantityLoad,
      cell: (row) => (
        <>
          <span className="fw-bold text-primary">{row?.orderQuantityLoad}</span>
        </>
      ),
      sortable: true,
      width: "120px",
    },

    {
      name: "Unit Price",
      selector: (row) => row.unitPrice,
      cell: (row) => (
        <>
          <span className="fw-bold text-primary">
            {formatNumber(row?.unitPrice, "comma")}
          </span>
        </>
      ),
      sortable: true,
      width: "120px",
    },

    {
      name: "Customer Addr",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row?.customerAddress} </p>
        </div>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Shiping Addr",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row?.shippingAddress}</p>
        </div>
      ),
      sortable: true,
      width: "150px",
    },

    {
      name: "Sales Officer",
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1 fw-bold ">{row.salesOfficer} </p>
          </div>
        </>
      ),
      selector: (row) => row.salesOfficer || "--",
      sortable: true,
      width: "140px",
    },
    {
      name: "Created By",
      selector: (row) => row.createdBy,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 ">{row.createdBy} </p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Created By",
      selector: (row) => row.createdBy,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 ">{row.createdBy} </p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
  ];

  const clearData = () => {
    setData();
  };
  // const handleInputChange = (documentNumber, event) => {
  //   const { name, value } = event.target;
  //   setData((prevRows) =>
  //     prevRows.map((row) =>
  //       row.documentNumber === documentNumber ? { ...row, [name]: value } : row
  //     )
  //   );
  // };

  const hideSupplierInviteModal = () => setShowSupplierInviteModal(false);
  const handleFormData = (data) => {
    setData(data);
    console.log(">>Received formData from child:", data);
    // You can set it in state or use it as needed
  };
  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={9} lg={9}>
                <h2 className="mainTitle">Order Bulk Upload</h2>
                <p className="subText">Order Bulk Upload List</p>
              </Col>
            </Row>
            <hr />

            {/* user list */}
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible1
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">OB</span>
                    </Col>
                    <Col xs={7} md={7} lg={7}>
                      <span className="headerTitle">Order Bulk Upload</span>
                      <span className="subHeaderTitle">
                        View of Order upload list
                      </span>
                    </Col>
                    <Col xs={1} md={1} lg={1}>
                      <button
                        className="btnTable"
                        onClick={() => setShowSupplierInviteModal(true)}
                      >
                        Upload
                      </button>
                    </Col>
                    <Col xs={1} md={1} lg={1}>
                      <button
                        className="btnTable"
                        // onClick={() => setShowSupplierInviteModal(true)}
                      >
                        Create
                      </button>
                    </Col>
                    <Col xs={1} md={1} lg={1}>
                      <button
                        className="btnTable btn-danger"
                        onClick={clearData}
                      >
                        Clear
                      </button>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible1 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={orderSchedulingListColInfo}
                          data={data}
                          // data={""}
                          // progressPending={orderSchedulingData?.status}
                          // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          // pagination
                          // paginationServer
                          // paginationTotalRows={orderSchedulingTable.total}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          // onSelectedRowsChange={handleRowSelect}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <UploadXlSheetModal
        show={getShowSupplierInviteModal}
        onHide={hideSupplierInviteModal}
        onFormDataChange={handleFormData}
      />
    </main>
  );
};

export default OrderBulckUpload;
